<template>
    <span :class="['event-status-pill', `event-status-pill--${status}`]">{{ langJson(label) }}</span>
</template>
<script>
import { STATUS_LABELS } from '@/assets/js/organizerEvent'

export default {
    props: {
        status: { type: String, required: true },
    },
    computed: {
        label() {
            return STATUS_LABELS[this.status] || this.status
        },
    },
}
</script>
<style lang="scss" scoped>
.event-status-pill {
    display: inline-flex;
    align-items: center;
    padding: 4px 12px;
    border-radius: 50px;
    font-family: 'Lato';
    font-size: 12px;
    line-height: 16px;
    white-space: nowrap;
    background: #f2f4f7;
    color: #667085;

    &--in_review {
        background: #fff6e5;
        color: #b54708;
    }
    &--approved,
    &--live {
        background: #e7f8ee;
        color: #12a150;
    }
    &--rejected {
        background: #fde8e8;
        color: #e5484d;
    }
    &--ended {
        background: #eef0f3;
        color: #6b7280;
    }
}
</style>
